function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M269.141,303.516c5.213,4.836,7.2,29.27,9.765,37.89,8.34,28.032,18.989,52.489,43.75,64.063,5.117,2.391,9.386,5.786,16.8,5.859,9.25-12.56,19.963-23.478,30.859-34.375l11.719-11.719h33.594l8.984,9.375,18.36,18.36c5.4,6.754,10.7,14.281,17.578,19.531,41.4-5.589,59.39-66.233,68.75-105.859l0.781,0.39c1.525,80.283-41.087,166.743-96.094,189.063-30.461,12.36-66.265,2.486-87.109-10.547C302,457.49,265.732,378.2,269.141,303.516Zm125.781,82.422c-9.153,3.3-45.543,14.861-41.016,26.562,9.944,21.05,78.389,22.22,89.844,1.562,2.985-6.318-4.828-10.521-8.594-12.89C423.307,393.716,414.709,385.722,394.922,385.938Z"
});

var SvgOmBeardScruffRoundOvalVector = function SvgOmBeardScruffRoundOvalVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "om_beard_scruff_round-oval_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmBeardScruffRoundOvalVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/om_beard_scruff_round__oval_vector.50f97595.svg";
export { ForwardRef as ReactComponent };